import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import ConditionEditor from './ConditionEditor';

const FormConditionEditor = ({
  forms,
  selectedForm,
  onSaveCondition,
  onRemoveCondition
}) => {
  const [localCondition, setLocalCondition] = useState({ logic: 'AND', groups: [] });
  const [approverOnly, setApproverOnly] = useState(false);

  useEffect(() => {
    setLocalCondition(selectedForm.condition || { logic: 'AND', groups: [] });
    setApproverOnly(selectedForm.approverOnly || false);
  }, [selectedForm]);

  const allFields = forms
    .flatMap(f => f.fields.map(field => ({ ...field, formName: f.name })));

  return (
    <>
      <h6 className="mt-4">Form Condition (Optional)</h6>

      <ConditionEditor
        value={localCondition}
        onChange={setLocalCondition}
        allFields={allFields.map(field => ({
          ...field,
          label: `${field.formName} - ${field.label}`
        }))}
      />
      <Form.Check
        className="mt-3"
        type="checkbox"
        label="Approver Only"
        checked={approverOnly}
        onChange={e => setApproverOnly(e.target.checked)}
      />
      <Button className="mt-3" onClick={() => {
        onSaveCondition(localCondition, approverOnly)
      }}>
        Save Form Condition
      </Button>

      {(selectedForm.condition && Object.keys(selectedForm.condition).length > 0) && (
        <Button
          variant="outline-danger"
          className="mt-3"
          onClick={onRemoveCondition}
        >
          ❌ Remove Condition
        </Button>
      )}
    </>
  );
};

export default FormConditionEditor;
